const o = "rula-ui";
class e {
  constructor(n, r, s, i) {
    this.name = n, this.red = r, this.green = s, this.blue = i;
  }
  /**
   * RGB string for this color. If you need the individual values, access those
   * values using their given variable name.
   */
  get rgb() {
    return `rgb(${this.red}, ${this.green}, ${this.blue})`;
  }
  /** Hex string version of the color */
  get hex() {
    return `#${[this.red, this.green, this.blue].map(
      (r) => r.toString(16).padStart(2, "0")
    ).join("")}`;
  }
  get variableName() {
    return this.name.replace(/[^\w\d]+/g, "-").toLowerCase();
  }
  get cssVariableName() {
    return `--${o}-${this.variableName}`;
  }
  /** CSS variable definition for this color */
  get cssVariableDefinition() {
    return `${this.cssVariableName}: ${this.hex}`;
  }
  toString() {
    return this.hex;
  }
}
const m = new e("White", 255, 255, 255), h = new e("Forest", 53, 69, 53);
function t(w) {
  const n = {};
  for (const [r, s] of Object.entries(w))
    n[r] = s, n[`${r}`] = s, n[`$${r}`] = s;
  return n;
}
const y = new e("Cream Primitive", 237, 234, 228), c = t({
  50: new e("Cream 50", 247, 245, 243),
  100: new e("Cream 100", 248, 245, 239),
  200: new e("Cream 200", 225, 221, 214),
  300: new e("Cream 300", 211, 208, 202)
}), a = t({
  // We use "grey" here because that is what it is in Figma.
  // Even if we are in the US...
  50: new e("Grey 50", 250, 250, 250),
  100: new e("Grey 100", 244, 245, 246),
  150: new e("Grey 150", 235, 237, 240),
  200: new e("Grey 200", 224, 226, 230),
  300: new e("Grey 300", 193, 197, 205),
  400: new e("Grey 400", 150, 154, 160),
  450: new e("Grey 450", 130, 132, 138),
  500: new e("Grey 500", 106, 108, 113),
  600: new e("Grey 600", 86, 87, 91),
  700: new e("Grey 700", 63, 65, 70),
  800: new e("Grey 800", 38, 39, 42),
  900: new e("Grey 900", 21, 23, 26)
}), b = a, l = t({
  10: new e("Red 10", 250, 232, 232),
  50: new e("Red 50", 206, 29, 29)
}), u = t({
  10: new e("Fern 10", 243, 250, 240),
  20: new e("Fern 20", 234, 245, 228),
  30: new e("Fern 30", 184, 227, 192),
  40: new e("Fern 40", 124, 188, 127),
  50: new e("Fern 50", 56, 102, 58),
  60: new e("Fern 60", 28, 51, 29)
}), A = t({
  10: new e("Sky 10", 240, 250, 249),
  20: new e("Sky 20", 217, 235, 233),
  30: new e("Sky 30", 183, 226, 224),
  40: new e("Sky 40", 87, 175, 176),
  50: new e("Sky 50", 41, 102, 98),
  60: new e("Sky 60", 18, 51, 49)
}), G = t({
  10: new e("Amethyst 10", 242, 242, 252),
  20: new e("Amethyst 20", 228, 228, 249),
  30: new e("Amethyst 30", 215, 204, 255),
  40: new e("Amethyst 40", 153, 126, 255),
  50: new e("Amethyst 50", 62, 46, 115),
  60: new e("Amethyst 60", 29, 23, 51)
}), g = t({
  10: new e("Amber 10", 251, 247, 241),
  20: new e("Amber 20", 251, 238, 219),
  30: new e("Amber 30", 241, 197, 177),
  40: new e("Amber 40", 242, 151, 111),
  50: new e("Amber 50", 102, 39, 20),
  60: new e("Amber 60", 51, 20, 10)
});
export {
  g as Amber,
  G as Amethyst,
  e as ColorDefinition,
  c as Cream,
  y as CreamPrimitive,
  u as Fern,
  h as Forest,
  a as Gray,
  b as Grey,
  l as Red,
  A as Sky,
  m as White
};
